import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ duration: 0.5, ease: [0.22,1,0.36,1] }}
        className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-sm z-50"
      >
        <div className="bg-[#0f0f0f] border border-[#1a1a1a] rounded-2xl p-5 shadow-2xl">
          <p className="font-syne text-xs font-bold text-white mb-1">We use cookies 🍪</p>
          <p className="font-dm text-[#999] text-xs leading-relaxed mb-4">
            We use cookies to enhance your browsing experience and analyze site traffic.
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => setVisible(false)}
              className="btn-lime flex-1 py-2 text-xs"
            >
              Accept All
            </button>
            <button
              onClick={() => setVisible(false)}
              className="btn-outline flex-1 py-2 text-xs"
            >
              Decline
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CookieBanner;
